import AbstractPage from './AbstractPage';
import { Swiper, Navigation, Lazy } from '../../../node_modules/swiper/dist/js/swiper.esm.js';

Swiper.use([Navigation, Lazy]);

export default class Gallery extends AbstractPage {
  declareProperties() {
    this.galleries = [...document.querySelectorAll('.swiper-container')];
    this.images = [...document.querySelectorAll('.social-media-images__image')];
    this.closeButtons = [...document.querySelectorAll('.gallery-container__close')];
  }

  init() {
    this.initGalleries();
    this.openLightBox();
    this.closeLightBox();
  }

  initGalleries() {
    this.galleries.forEach(e => {
      new Swiper(e, {
        preloadImages: false,
        lazy: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    });
  }

  openLightBox() {
    this.images.forEach(el => {
      el.addEventListener('click', e => {
        const target = e.currentTarget;
        let index = Array.from(target.parentNode.children).indexOf(target),
          type = target.getAttribute('data-gallery-type'),
          gallery = document.querySelector('[data-gallery-type="' + type + '"].gallery-container'),
          slider = gallery.querySelector('.swiper-container').swiper;

        slider.slideTo(index, 0);

        gallery.classList.add('show');
      });
    });
  }

  closeLightBox() {
    this.closeButtons.forEach(el => {
      el.addEventListener('click', e => {
        e.target.closest('.gallery-container').classList.remove('show');
      });
    });
  }
}
